// extracted by mini-css-extract-plugin
module.exports =  {"container":"VJhhDyC1","pill":"m7_vGK5b","arrow":"HSlqfOPi","copy":"B718t12V","pillCopy":"B_ijQs5E"};